let signHome = {
    path: '/tools/sign',
    name: 'SignHome',
    component: () => import(`@/views/signDataAnalysis/SignHome.vue`),
    meta: {'title': '活动工具', 'keepAlive': false},
    redirect: '/tools/sign/index',
    children: [
        {
            path: '/tools/sign/index',
            name: 'index',
            component: () => import(`@/views/signDataAnalysis/Index.vue`),
            meta: {'title': '签到数据分析', 'keepAlive': false},
            redirect: '/tools/sign/index',
            children: [
                {
                    path: '/tools/sign/index',
                    name: 'Index',
                    component: () => import(`@/views/signDataAnalysis/Index.vue`),
                    meta: {'title': '首页', 'keepAlive': false}
                }
            ]
        },
        {
            path: '/tools/sign/index',
            name: 'nameMgt',
            component: () => import(`@/views/signDataAnalysis/NameMgt.vue`),
            meta: {'title': '名单管理', 'keepAlive': false},
            redirect: '/tools/sign/nameMgt',
            children: [
                {
                    path: '/tools/sign/nameMgt',
                    name: 'NameMgt',
                    component: () => import(`@/views/signDataAnalysis/NameMgt.vue`),
                    meta: {'title': '名单管理', 'keepAlive': false}
                }
            ]
        },
        {
            path: '/tools/sign/signWall',
            name: 'signWall',
            component: () => import(`@/views/signDataAnalysis/SignWall.vue`),
            meta: {'title': '签到墙', 'keepAlive': false},
            redirect: '/tools/sign/signWall',
            children: [
                {
                    path: '/tools/sign/signWall',
                    name: 'SignWall',
                    component: () => import(`@/views/signDataAnalysis/SignWall.vue`),
                    meta: {'title': '签到墙', 'keepAlive': false}
                }
            ]
        }
    ]
}
export default [signHome]